/* assets/pnd-header-divowa.js
   Pondéra : le voile de page (snippets/pnd-veilleuse.liquid) ne suit que les entrées de la barre
   de gauche. Les liens placés à droite (Aide...) sont dans la navigation secondaire :
   ce script allume le même voile quand l'un de leurs panneaux s'ouvre.
   Aucun effet si la Veilleuse n'est pas là.
   Charge aussi à l'avance les photos des panneaux quand la souris arrive sur l'en-tête. */
(function () {
  "use strict";

  function sync(header) {
    var scrim = document.querySelector(".pndv-scrim");
    if (!scrim) return;
    scrim.classList.toggle("is-on", !!header.querySelector('.header__menu-disclosure[aria-expanded="true"]'));
  }

  /* les photos des panneaux sont chargées dès que la souris approche du menu (ordinateur) */
  function warm(e) {
    if (!window.matchMedia || !window.matchMedia("(min-width: 1000px)").matches) return;
    var imgs = document.querySelectorAll(".pndd img[loading=lazy]");
    for (var i = 0; i < imgs.length; i++) imgs[i].loading = "eager";
    e.currentTarget.removeEventListener("pointerenter", warm);
  }

  function init() {
    var header = document.querySelector(".header");
    if (!header || header.dataset.pnddObs === "1" || !window.MutationObserver) return;
    header.dataset.pnddObs = "1";
    header.addEventListener("pointerenter", warm);
    new MutationObserver(function () { sync(header); }).observe(header, {
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-expanded", "open"]
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
